module.exports = __webpack_public_path__ + "static/optimo-zaleta-4-e81b7d0891bc327fefaf6a0a5c3b465b.png";